import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
export function AudienceSection() {
  const forWho = ['Anyone with a wedding, beach day, or event in the next 3-4 days.', 'People who feel "flat" in the morning but look 3 months pregnant by 4 PM.', 'Office workers who struggle with "sit-pain" and digestive sluggishness.', 'Those tired of spending $50+ on "de-bloat" pills that don\'t work.'];
  const notForWho = ['Individuals with chronic medical G.I. diseases requiring clinical supervision.', 'Anyone looking for a "magic pill" weight loss solution (this is a mechanical reset).', 'People unwilling to swap raw salads for cooked meals for 72 hours.'];
  return <section className="py-16 px-6 max-w-4xl mx-auto" data-id="element-1">
      <div className="grid md:grid-cols-2 gap-8" data-id="element-2">
        <FadeIn data-id="element-3">
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-sage/20 h-full" data-id="element-4">
            <h3 className="font-serif text-2xl text-charcoal mb-6 flex items-center gap-2" data-id="element-5">
              <CheckCircle2 className="text-sage" data-id="element-6" />
              Who this is for
            </h3>
            <ul className="space-y-4" data-id="element-7">
              {forWho.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-8">
                  <div className="w-1.5 h-1.5 rounded-full bg-sage mt-2 flex-shrink-0" data-id="element-9" />
                  <span className="font-sans text-charcoal-light" data-id="element-10">{item}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-11">
          <div className="bg-cream-dark p-8 rounded-2xl border border-terracotta/20 h-full" data-id="element-12">
            <h3 className="font-serif text-2xl text-charcoal mb-6 flex items-center gap-2" data-id="element-13">
              <XCircle className="text-terracotta" data-id="element-14" />
              Who this is NOT for
            </h3>
            <ul className="space-y-4" data-id="element-15">
              {notForWho.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-16">
                  <div className="w-1.5 h-1.5 rounded-full bg-terracotta mt-2 flex-shrink-0" data-id="element-17" />
                  <span className="font-sans text-charcoal-light" data-id="element-18">{item}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}